import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
